{
  "version": 1,
  "asset_id": "8ba98097-5d18-4764-a3d9-8a86d461eb98",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8ba98097-5d18-4764-a3d9-8a86d461eb98/hiatal-type-2-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8ba98097-5d18-4764-a3d9-8a86d461eb98/hiatal-type-2-v3-1200.webp",
  "original_filename": "hiatal-type-2-v3-1200.webp",
  "size": 137922,
  "content_type": "image/webp",
  "created_at": "2026-10-28T19:42:16Z"
}
